import React from "react";
import Box from "@mui/material/Box";
import HotelTabs from "../components/Hotel/Tabs";
import HotelPolicy from "../components/Hotel/Hotel-Policy";

const HotelPolicyPage = () => {
    return (
        <Box sx={{ width: "100%" }}>
            <HotelTabs />
            <HotelPolicy />
        </Box>
    );
};

export default HotelPolicyPage;
